import { $api } from "../AxiosInstance";

export class CrmService {
  static async getHistoryCrm(params) {
    return await $api.post("/api/admin/crm/request/history/query", {
      ...params,
      page: params.page - 1,
    });
  }

  static async getRequestTypes() {
    return await $api.get("/api/admin/crm/request/history/types");
  }

  static async getHistoryCrmItemById(id) {
    return await $api.get("/api/admin/crm/request/history/byId", { params: { id } });
  }
}
